import React from 'react'
import {Badge, Row,} from "reactstrap";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";

const propTypes = {};
let resourceStrings = new LocalizedStrings(resource_strings);

export default class ResourceItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};

        console.log(this.props)
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextProps.item_extra !== this.props.item_extra
    }

    render() {
        this.localize();

        return (
            <div
                style={{
                    cursor: "pointer",
                    borderRadius: 10,
                    padding: 14,
                    marginTop: 10,
                    display: "flex",
                    flexFLow: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: "#555566",
                    width: '100%'
                }}
                className="mt-2"
                color="default"
                onClick={e => this.props.onSelected(e, this.props.item_name)}>

                <div style={{
                    display: "flex",
                    flexFLow: "row",
                    minWidth: 259,
                    maxWidth: 259,
                    alignContent: "center",
                    justifyContent: "left",
                }}>
                 <span className="btn-inner--icon">
                    {this.props.icon &&
                    // <TicketIcon style={{marginRight: '0.5rem', color: '#333', width: 24, height: 24}} />
                    <img
                        style={{marginRight: '0.5rem', color: `#645484`, marginLeft: 10}}
                        width={18}
                        height={18}
                        alt="pm"
                        src={this.props.icon}
                    />
                    }
                 </span>

                    <div style={{display: "flex", flexFlow: "row", flexWrap: "wrap", justifyContent: "left", alignItems: "center"}}>
                        {this.props.smallText ?
                            (<small>
                                <div style={{
                                    color: "white",
                                    overflow: 'hidden',
                                    textOverflow: "ellipsis",
                                    fontWeight: 500
                                }}>
                                    {this.props.item_name ? this.props.item_name : "..."}
                                </div>
                            </small>) :
                            <div style={{
                                color: "white",
                                overflow: 'hidden',
                                textOverflow: "ellipsis",
                                fontWeight: 500
                            }}>
                                {this.props.item_name ? this.props.item_name : "..."}</div>
                        }

                        {this.props.invalidForClass &&
                        <Row>
                            <small style={{color: "red", marginLeft: 16}}>
                                {resourceStrings.no_valid_for_class}
                            </small>
                        </Row>
                        }

                        <span className="mb-0 text-sm"
                              style={{marginLeft: 14}}>

                    {this.props.membership &&
                    <Badge color="white">
                        {resourceStrings.membership}
                    </Badge>
                    }

                            {this.props.is_enrolment &&
                            <Badge color="white">
                                {resourceStrings.is_enrolment}
                            </Badge>
                            }

                            {this.props.additionaInfo &&
                            <small style={{color: "white", fontWeight: 600}}>
                                {this.props.additionaInfo}
                            </small>
                            }
                    </span>

                    </div>
                </div>


                <span className="mb-0 text-sm" style={{color: "white", fontWeight: 600, minWidth: 50}}>
                        {this.props.item_extra ? this.props.item_extra : ""}
                    </span>
            </div>
        )
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        resourceStrings.setLanguage(loc);
    }

}

ResourceItem.propTypes = propTypes;